﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const form_controls_1 = require("@its-suite/form-controls");
const operational_context_client_1 = require("@its-suite/operational-context-client");
class ExtendedAttributeUtil {
    static getExtendedAttributeColumnType(type) {
        var _a;
        return (_a = ExtendedAttributeUtil.fromTypeToColumnDataTypeMap.get(type)) !== null && _a !== void 0 ? _a : form_controls_1.ColumnDataType.STRING;
    }
}
exports.ExtendedAttributeUtil = ExtendedAttributeUtil;
ExtendedAttributeUtil.buildExtendedAttributes = (entityName, attributesValues) => {
    const result = { entityName: entityName, attributes: new Map() };
    if (attributesValues) {
        Object.keys(attributesValues).forEach(key => {
            result.attributes.set(key, attributesValues[key]);
        });
    }
    return result;
};
ExtendedAttributeUtil.getEntityExtendedAttributes = (entity, extendedValues) => {
    let result = {};
    if (extendedValues) {
        const entityData = extendedValues.find((item) => item.entityName === entity);
        if (entityData) {
            entityData.attributes.forEach((value, key) => {
                result = Object.assign(Object.assign({}, result), { [key]: value });
            });
        }
    }
    return result;
};
ExtendedAttributeUtil.fromTypeToColumnDataTypeMap = new Map([
    [operational_context_client_1.ValueType.BOOLEAN, form_controls_1.ColumnDataType.ICON_BOOLEAN],
    [operational_context_client_1.ValueType.DATETIME, form_controls_1.ColumnDataType.DATE]
]);
//# sourceMappingURL=ExtendedAttributeUtils.js.map